export enum Steps {
    Content = 0,
    Options = 1
}